import { FC, useEffect, useMemo, useState } from 'react'
import * as Yup from 'yup'
import { ErrorMessage, Field, FieldArray, Form, Formik, FormikErrors } from 'formik'
import { Adapter, IFormSelfAssess, IFormSelfAssessItem, IFormSelfAssessSetting, SeasonDto, SelfAssessService, categoryEnum } from '../../modules/core'
import { catchErrorMsg } from '../../modules/core/helpers/Helper'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import { FormRadio } from 'app/components'
import { PageTitle } from '_metronic/layout/core'
import { SelfAssessDto, SelfAssessRequestDto } from 'app/modules/core/models/dto/SelfAssessment'
import { RootState } from 'setup'
import { shallowEqual, useSelector } from 'react-redux'
import moment from 'moment'

type Props = {

}

let initValue: IFormSelfAssess = {
  items: []
}
const formSchema = Yup.object().shape({
  // name: Yup.string().required('require'),
  // description: Yup.string().required('require'),
  // //price: Yup.number().min(1, 'more than zero').required('require'),
  // isActive: Yup.boolean().required('require'),
  // code: Yup.string().required('require'),
})



export const SelfAssessDetailPage: FC<Props> = () => {

  const lastSeason = useSelector<RootState>(({ core }) => core.lastSeason, shallowEqual) as SeasonDto
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState<IFormSelfAssess>(initValue)
  const [dataSetting, setDatSetting] = useState<SelfAssessDto[]>()
  const [seasonMonth, setSeasonMonth] = useState<string>(moment(new Date()).format("YYYY-MMM-01"))

  const { period } = useParams()
  const navigate = useNavigate()

  useMemo(() => {
    SelfAssessService.GetSelfAssesssSetting().then((result) => {
      const res = result.data.result
      if (res && res.length > 0) {
        setDatSetting(res)
        const frmDto = Adapter.FormSelfAssess(res);
        setData(frmDto)
      }
    })
  }, [])


  useEffect(() => {
    const init = () => {
      if (period && period !== 'new' && dataSetting && dataSetting.length > 0) {
        setSeasonMonth(`${period}-01`)
        SelfAssessService.GetByPeriod(period).then((result) => {
          const res = result.data.result
          if (res && res.length > 0) {
            const dataToset: IFormSelfAssess = { items: [] }
            dataSetting.map((item, index) => {

              const ans = res.find(x => x.category === item.category)
              const model: IFormSelfAssessItem = {
                assessTypeId: 1,
                category: item.category,
                title: item.title,
                point: item.point,
                answer: ans && ans.point > 0 ? false : true,
                seasonId: 0
              }
              dataToset.items.push(model)
            })
            //const frmDto = Adapter.FormSelfAssess(res);
            setData(dataToset)
          }

        })
      }
      setLoading(false)
    }
    init()
  }, [period, dataSetting])

  const onSubmit = async (values: IFormSelfAssess) => {
    setLoading(true)
    if (!seasonMonth) {
      toast.error('season โหลดไม่ถูกต้อง')
      setLoading(false)
      return;
    }
    if (!lastSeason?.id) {
      toast.error('season โหลดไม่ถูกต้อง')
      setLoading(false)
      return
    }

    
    const d = moment(seasonMonth,"YYYY-MMM-DD").toDate() 
    const updatedData = values.items.map((item) => Adapter.mapSelfAsess(item, d, lastSeason.id))

    if (period && period === 'new') {
      Save(updatedData)
    } else if (period) {
      Update(period, updatedData)
    }


  }

  const Save = (updatedData: SelfAssessRequestDto[]) => {
    SelfAssessService.CreateMany(updatedData)
      .then((res) => {
        toast.success('Save Success.')
        setLoading(false)
        navigate('/selfAssess')
      }).catch((res) => {        
        toast.error(catchErrorMsg(res))
        setLoading(false)
      })
  }

  const Update = (period: string, updatedData: SelfAssessRequestDto[]) => {
    SelfAssessService.UpdatePeriod(period, updatedData).then(() => {
        toast.success('Update Success.')
        setLoading(false)
        navigate('/selfAssess')
      }).catch((res) => {
        toast.error(catchErrorMsg(res))
        setLoading(false)
      })
  }

  const seasonOption = () => {
    if (!lastSeason) return <></>
    const opt: any[] = []
    const runningMonth = new Date(lastSeason.periodStart)
    const endLoopDate = new Date(lastSeason.periodEnd)
    let cnt = 0;
    while (runningMonth < endLoopDate) {
      opt.push(<option key={cnt}
        value={moment(runningMonth).format("YYYY-MMM-DD")}
      >{moment(runningMonth).format("YYYY MMM")}</option>)
      runningMonth.setMonth(runningMonth.getMonth() + 1)
      cnt++
    }
    return opt;
  }

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'ประเมินตนเอง',
            path: '/selfAssess',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        ประเมินตนเอง
      </PageTitle>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header cursor-pointer'>
          <div className='card-title m-0 d-flex flex-column'>
            <h3 className='fw-bolder p-5'>{lastSeason?.title}</h3>
            <h3 className='fw-bolder p-5 d-flex justify-content-between'><span className='pe-5'>เลือกเดือนประเมิน</span> <span>
              <select className='form-control select' onChange={(e) =>
                e.target?.value && setSeasonMonth(e.target.value)}
                value={seasonMonth}
                disabled={period !== 'new'}>
                {seasonOption()}
              </select>
            </span></h3>
          </div>
        </div>
        <Formik
          enableReinitialize
          initialValues={data}
          validationSchema={formSchema}
          onSubmit={onSubmit}
          validate={(v) => console.log(v)}
        >
          {({ values, handleSubmit, setFieldValue, errors, touched }) => (
            <Form>
              <>
                {/* begin::Scroll */}
                <div className='card-body p-9'>

                  <FieldArray
                    name='items'
                    render={() => {
                      return (
                        <div>
                          {values.items && values.items.length > 0 ? (
                            values.items.map((item, index) => {
                              return (
                                <div key={index}>
                                  <div className='pb-8 pb-lg-10'>
                                    <label className='form-label'>{`${index + 1}. ${item.title}`}</label>
                                    <label className='d-flex flex-stack mb-5 cursor-pointer'>
                                      <span className='form-check form-check-custom form-check-solid'>                                        
                                        <Field
                                          label={'ไม่ใช่'}
                                          name={`items.${index}.answer`}
                                          gName={item.category}
                                          gValue={false}
                                          component={FormRadio}
                                        />
                                        <div className='pe-5'>
                                          <Field
                                            label={'ใช่'}
                                            name={`items.${index}.answer`}
                                            gName={item.category}
                                            gValue={true}
                                            component={FormRadio}

                                          />
                                        </div>
                                      </span>

                                    </label>
                                  </div>
                                </div>
                              )
                            })
                          ) : (
                            <></>
                          )}
                        </div>
                      )
                    }}
                  />
                  <div className=' d-flex fs-4'> {'ข้าพเจ้าตรวจสอบการประเมินอย่างรอบครอบแล้ว (ไม่สามารถแก้ไขการประเมินได้อีก)'}</div>
                </div>
                {/* end::Scroll */}

                <div className='card-footer d-flex py-6 px-9'>
                  <button type='submit' className='btn btn-primary pe-5  me-10' disabled={loading}>
                    {!loading && 'Save Changes'}
                    {loading && (
                      <span className='indicator-progress' style={{ display: 'block' }}>
                        Please wait...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>

                  <button className='btn btn-light' onClick={() => navigate('/selfAssess')}> Back</button>
                </div>
              </>
            </Form>
          )}
        </Formik>
      </div>
    </>
  )
}

